/* eslint-disable react/display-name */
import React, { useCallback } from 'react';
import { useRouter } from '@24i/nxg-core-router/src/NextRouter';
import SingOutModalView from '../components/SignOutModalView';

function withSignoutModal<P>(Component: React.ComponentType<P>) {
    return (hocProps: Omit<P, 'setSignoutModalVisible'>) => {
        const router = useRouter();

        const onCloseModal = useCallback(() => {
            router.back();
        }, [router]);

        return (
            <SingOutModalView
                Component={Component}
                onCloseModal={onCloseModal}
                componentProps={hocProps}
            />
        );
    };
}

export default withSignoutModal;
